import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when request with socket was failed due to any error response.
 * @memberOf Playtech.API.events
 * @event socket-error
 * @type {callback}
 * @param {object} detials
 * @param {number} details.requestId - Request ID.
 * @param {number} details.responseId - Response ID.
 * @param {number} details.errorCode - Error code as received from socket if any.
 * @param {number} details.error - Error code as received from socket if any.
 * @param {number} details.time - Time it took to make the request is ms.
 * @example Playtech.on('socket-error', ({ requestId, responseId, errorCode, error, time }) => { ... });
 */
export const SOCKET_ERROR = 'socket-error';

export const useOnSocketError = (eventTarget: EventTarget): void => {
    const triggerSocketErrorEvent = useCallback((detail: {
        requestId: number;
        responseId: number;
        errorCode: number;
        error: object;
        time: number;
    }) => {
        const event = new CustomEvent(SOCKET_ERROR, { detail });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('socket-error', triggerSocketErrorEvent);

        return () => {
            publicEventsAPIService.off('socket-error', triggerSocketErrorEvent);
        };
    }, [triggerSocketErrorEvent]);
};
